const TRIGGER_SELECTOR = '[data-wf--modal-trigger--variant="video"]';
const MODAL_SELECTOR = ".section__modal--video";
const CLOSE_SELECTOR = ".modal__close--video";
const BACKGROUND_PARAMS = ["background", "muted", "loop", "autoplay"];
const VIMEO_ORIGIN = "https://player.vimeo.com";
// Safety net in case `transitionend` never fires (e.g. reduced motion); the fade is 0.4s.
const VISIBLE_FALLBACK_MS = 500;

function getPlayerSrc(iframe) {
  const source = iframe.dataset.src;

  if (!source) return "";

  const url = new URL(source, window.location.href);

  BACKGROUND_PARAMS.forEach((param) => url.searchParams.delete(param));

  return url.toString();
}

function postToPlayer(iframe, message) {
  iframe.contentWindow?.postMessage(JSON.stringify(message), VIMEO_ORIGIN);
}

function initVideoModal() {
  const modal = document.querySelector(MODAL_SELECTOR);
  const iframe = modal?.querySelector("iframe");

  if (!modal || !iframe) return;

  // Keep the player unloaded until the user asks for it.
  if (!iframe.dataset.src && iframe.getAttribute("src")) {
    iframe.dataset.src = iframe.getAttribute("src");
  }
  iframe.removeAttribute("src");

  let isVisible = false;
  let isReady = false;
  let fallbackTimer;

  function play() {
    if (isVisible && isReady) postToPlayer(iframe, { method: "play" });
  }

  function markVisible() {
    clearTimeout(fallbackTimer);
    isVisible = true;
    play();
  }

  function open() {
    isVisible = false;
    isReady = false;
    modal.classList.add("is-open");
    // Load the player right away; playback waits until the modal is fully visible.
    iframe.src = getPlayerSrc(iframe);
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(markVisible, VISIBLE_FALLBACK_MS);
  }

  function close() {
    if (!modal.classList.contains("is-open")) return;

    modal.classList.remove("is-open");
    clearTimeout(fallbackTimer);
    isVisible = false;
    isReady = false;
    // Dropping src stops playback and audio.
    iframe.removeAttribute("src");
  }

  modal.addEventListener("transitionend", (event) => {
    if (
      event.target === modal &&
      event.propertyName === "opacity" &&
      modal.classList.contains("is-open")
    ) {
      markVisible();
    }
  });

  iframe.addEventListener("load", () => {
    if (!iframe.getAttribute("src")) return;

    postToPlayer(iframe, { method: "addEventListener", value: "ready" });
  });

  window.addEventListener("message", (event) => {
    if (event.origin !== VIMEO_ORIGIN || event.source !== iframe.contentWindow) return;

    let data = event.data;

    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch {
        return;
      }
    }

    if (data?.event === "ready") {
      isReady = true;
      play();
    }
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest(TRIGGER_SELECTOR)) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest(CLOSE_SELECTOR)) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
}

initVideoModal();
